
        var result = require("!!../../../node_modules/css-loader/index.js!./submenu.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/menu/submenu.component.css
// module id = 2133
// module chunks = 1